import { AppDispatch, AppState } from "@/store/configureStore";
import {
	decrementQuantity,
	incrementQuantity,
	setCartLoading,
} from "@/store/slices/cartSlice";
import axios from "axios";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import useRemoveDiscountIfNeeded from "./useRemoveDiscountIfNeeded";

const useProductQuantity = () => {
	const cart = useSelector((state: AppState) => state.cart);
	const base_url = process.env.NEXT_PUBLIC_BASE_URL;
	const dispatch = useDispatch<AppDispatch>();
	const removeDiscountIfNeeded = useRemoveDiscountIfNeeded();

	const increaseQuantity = async (productId: string | undefined) => {
		try {
			dispatch(setCartLoading(true));
			await removeDiscountIfNeeded();
			const response = await axios.put(
				`${base_url}/api/cart/product/${productId}/increase`,
				{
					cartId: cart.id,
				}
			);

			dispatch(
				incrementQuantity({
					productId: productId,
					totalPrice: response?.data?.cart?.totalPrice,
				})
			);
			// console.log(response.data);
			toast.remove();
			toast.success("Cart item updated");
		} catch (error: string | any) {
			// console.log(error);
		} finally {
			dispatch(setCartLoading(false));
		}
	};

	const decreaseQuantity = async (productId: string | undefined) => {
		try {
			dispatch(setCartLoading(true));
			await removeDiscountIfNeeded();
			const response = await axios.put(
				`${base_url}/api/cart/product/${productId}/decrease`,
				{
					cartId: cart.id,
				}
			);

			dispatch(
				decrementQuantity({
					productId: productId,
					totalPrice: response?.data?.cart?.totalPrice,
				})
			);
			toast.remove();
			toast.success("Cart item updated");
		} catch (error: string | any) {
			toast.remove();
			toast.error(error.response?.data?.msg);
		} finally {
			dispatch(setCartLoading(false));
		}
	};

	return {
		increaseQuantity,
		decreaseQuantity,
	};
};

export default useProductQuantity;
